var module = angular.module('main.resellerorder');

module.component('createResellerReturnOrderHeader',{
    templateUrl: 'main/resellerorder/resellerreturnordercreate/components/createreturnorderheader.cmp.tpl.html',
    bindings: {
        resellerOrder: '='
    },
    controllerAs: 'vm',
    controller: ['$window','$scope','ResellerOrdersApiService','ToasterService',componentController]
});

// @ngInject
function componentController($window, $scope, ResellerOrdersApiService, ToasterService) {
    var vm = this;

    //Properties
    vm.stores = [];
    vm.resellers = [];
    vm.warehouses = [];
    vm.collections = [];
    vm.selectedReseller = {};
    vm.selectedSaleLocation = {};
    vm.selectedWarehouse = {};
    vm.selectedCollection= {};

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    activate();

    function activate() {
        $scope.$watch(function () { return vm.selectedReseller.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.resellerOrder.resellerId = newValue;
            }
        });
        $scope.$watch(function () { return vm.selectedSaleLocation.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.resellerOrder.saleLocationId = newValue;
                saveLastUsedSaleLocationId(newValue);
            }
        });
        $scope.$watch(function () { return vm.selectedWarehouse.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.resellerOrder.warehouseId = newValue;
                saveLastUsedWarehouseId(newValue);
            }
        });
        $scope.$watch(function () { return vm.selectedCollection.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                vm.resellerOrder.collectionId = newValue;
                saveLastUsedCollectionId(newValue);
            }
        });
    }

    function onInit() {
        ResellerOrdersApiService.getWarehouses().then(function(response) {
            vm.warehouses = response.warehouses;
            var lastUsedWarehouseId = getLastUsedWarehouseId();
            vm.selectedWarehouse = _.find(vm.warehouses, function(o) { return o.id === lastUsedWarehouseId; });
        }, function(error) {
            ToasterService.showError(error.message);
        });

        ResellerOrdersApiService.getStores().then(function(response) {
            vm.stores = response.stores;
            var lastUsedSaleLocationId = getLastUsedSaleLocationId();
            vm.selectedSaleLocation = _.find(vm.stores, function(o) { return o.id === lastUsedSaleLocationId; });
        }, function(error) {
            ToasterService.showError(error.message);
        });

        ResellerOrdersApiService.getResellers().then(function(response) {
            vm.resellers = response.resellers;
        }, function(error) {
            ToasterService.showError(error.message);
        });

        ResellerOrdersApiService.getOrderCollections().then(function(response) {
            vm.collections = response;
            var lastUsedCollectionId = getLastUsedCollectionId();
            vm.selectedCollection = _.find(vm.collections, function(o) { return o.id === lastUsedCollectionId; });
        }, function(error) {
            ToasterService.showError(error.message);
        });
    }
    function onChanges() {
    }

    function getLastUsedSaleLocationId() {
        if ($window.localStorage.createorderheader_lastUsedSaleLocationId) {
            var lastUsedSaleLocationId = parseInt($window.localStorage.getItem('createorderheader_lastUsedSaleLocationId'));
            if (isNaN(lastUsedSaleLocationId)) { return undefined; }
            return lastUsedSaleLocationId;
        }
        return undefined;
    }
    function getLastUsedWarehouseId() {
        if ($window.localStorage.createorderheader_lastUsedWarehouseId) {
            var lastUsedWarehouseId = parseInt($window.localStorage.getItem('createorderheader_lastUsedWarehouseId'));
            if (isNaN(lastUsedWarehouseId)) { return undefined; }
            return lastUsedWarehouseId;
        }
        return undefined;
    }
    function getLastUsedCollectionId() {
        if ($window.localStorage.createorderheader_lastUsedCollectionId) {
            var lastUsedCollectionId = parseInt($window.localStorage.getItem('createorderheader_lastUsedCollectionId'));
            if (isNaN(lastUsedCollectionId)) { return undefined; }
            return lastUsedCollectionId;
        }
        return undefined;
    }
    function saveLastUsedSaleLocationId(id) {
        $window.localStorage.setItem('createorderheader_lastUsedSaleLocationId', id);
    }
    function saveLastUsedWarehouseId(id) {
        $window.localStorage.setItem('createorderheader_lastUsedWarehouseId', id);
    }
    function saveLastUsedCollectionId(id) {
        $window.localStorage.setItem('createorderheader_lastUsedCollectionId', id);
    }
}
